<template>
  <div class="top-menu">
    <div class="list">
      <div
        :class="activeIndex === index ? 'active list-item':'list-item'"
        v-for="(item, index) in list"
        :key="index"
        @click="toPage(item, index)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      activeIndex: 0,
    };
  },

  watch: {
    $route(to, form) {
      this.refresh(this.list)
    }
  },

  created() {},
  mounted() {
    this.$bus.on("getTopMenuList", (v) => {
      this.list = v;
      this.refresh(v)
    });
  },

  methods: {
    toPage(row, index) {
      this.activeIndex = index
      this.$router.push(`${row.url}`);
    },

    refresh(v) {
      /* 刷新留在当前页面 */
      let url = this.$route.path
      v.map((i, index) => {
        if (i.url === url) {
          this.activeIndex = index
        }
      })
    }
  },
};
</script>

<style lang='scss' scoped>
.top-menu {
  height: 56px;
  line-height: 56px;
  background: $bg-white;
  padding: 0px 22px;
  .list {
    @include flex-center;
    .list-item {
      font-weight: 400;
      font-size: $fs-medium-s;
      color: $color-BlackGrey;
      margin-right: 32px;
      cursor: pointer;
    }
    .active {
      height: 54px;
      color: $color-DeepReddishBlue;
      border-bottom: 2px solid $color-DeepReddishBlue;
    }
  }
}
</style>
